import { getWhatsAppOrigin } from './whatsappMessagePresentation';
// Presentation only. Server-side proofs and receipts control transport authority.
export function whatsappDeliveryLabel({ managed, messageType, private: isPrivate, attributes = {}, history, status }) {
  if (!managed || messageType !== 1 || attributes.deleted) return null;
  const meta = attributes.bcwDeliveryV1 || attributes.bcw_delivery_v1;
  const trustedOrigin = getWhatsAppOrigin(attributes, history);
  const phone = trustedOrigin === 'phone';
  const historical = trustedOrigin === 'history';
  // Private records without verified external provenance remain real notes.
  if (isPrivate && !trustedOrigin) return null;
  if (!meta && !phone && !historical) return null;
  // Legacy sent values are import defaults, not provider delivery receipts.
  if (!meta && historical && !phone) {
    return { origin: 'history', warning: false, text: '历史同步' };
  }
  if (isPrivate && !meta && !phone) return null;
  const origin = trustedOrigin || meta?.origin || 'phone';
  const names = { web: '网页发送', phone: '手机发送', history: '历史同步', external: '外部同步' };
  const state = meta?.state || status;
  const labels = { pending: '发送中', progress: '发送中', unknown: '投递待核对', failed: '发送失败', sent: '已发送', delivered: '已送达', read: '对方已读' };
  const warning = ['unknown', 'failed'].includes(state);
  const suffix = (meta?.played && state === 'read') ? '语音已播放' : meta?.reason === 'legacy_unconfirmed' ? '历史投递未确认' : labels[state];
  return { origin, warning, text: [names[origin] || 'WhatsApp', suffix].filter(Boolean).join(' · ') };
}
